import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/Home'
import AdminPages from '@/components/admin/AdminPages'
import ArticlesByCategory from '@/components/article/ArticlesByCategory'
import ArticleById from '@/components/article/ArticleById'
import Auth from '@/components/auth/Auth'
import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [{
    name: 'home',
    path: '/',
    component: Home,
}, {
    name: 'adminPages',
    path: '/admin',
    component: AdminPages,
    meta: { requiresAuth: true }
}, {
    name: 'articlesByCategory',
    path: '/category/:name/:id',
    component: ArticlesByCategory,
}, {
    name: 'articleById',
    path: '/article/:name',
    component: ArticleById,
}, {
    name: 'login',
    path: '/login',
    component: Auth,
    meta: { noRequiresAuth: true }
}, {
    path: "*",
    redirect: "/"
}]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = sessionStorage.getItem(userKey)
    // const userData = JSON.parse(loggedIn);
    if (to.matched.some(record => record.meta.noRequiresAuth) && loggedIn) {

        return next({ name: "home" })
    }
    if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {

        return next({ name: "login" })
    }
    // if (to.matched.some(record => record.meta.requiresAdmin)) {

    //     return next({ name: "home" })
    // }
    return next();
});


export default router;